import React from 'react';
import { Col } from 'react-bootstrap';

const FormCol4 = props => (
  <Col sm={12} lg={4} xl={4} {...props}>
    {props.children}
  </Col>
);

export default FormCol4;

